import triggersService from '@/services/triggersService'
import i18n from '@/plugins/i18n'

const state = {
  // ListTriggers
  triggers: [],
  totalTriggers: 0,
  paginationTriggers: {},
  triggerActionTypes: [],
  triggerToDoList: [],

  // View Trigger
  showViewEditTriggerDialog: false,
  search: '',
  title: '',
  triggerUsers: [],
  totalTriggerUsers: 0,
  paginationTriggerUsers: {},

  // Update Trigger
  selectedTrigger: {}
}

const mutations = {
  'SET_TRIGGERS' (state, triggers) {
    state.triggers = triggers
  },
  'SET_TRIGGER_USERS' (state, triggerUsers) {
    state.triggerUsers = triggerUsers
  },
  'SET_SELECTED_TRIGGER' (state, trigger) {
    if (!trigger.id && trigger._id) trigger.id = trigger._id
    state.selectedTrigger = trigger
  },
  'SET_TOTAL_TRIGGERS' (state, total) {
    state.totalTriggers = total
  },
  'SET_TOTAL_TRIGGER_USERS' (state, total) {
    state.totalTriggerUsers = total
  },
  'SET_TRIGGER_ACTION_TYPES_LIST' (state, actionTypes) {
    state.triggerActionTypes = actionTypes
  },
  'SET_TRIGGER_TODO_LIST' (state, todos) {
    state.triggerToDoList = todos
  },
  'SET_PAGINATION_TRIGGERS' (state, pagination) {
    state.paginationTriggers = pagination
  }
}

const actions = {
  async createTrigger (vuexContext, data) {
    try {
      await triggersService.createTrigger(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        data
      )
    } catch (e) {
      console.log(e)
    }
  },
  async getTrigger (vuexContext, id) {
    try {
      const response = await triggersService.getTrigger(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        id
      )
      const trigger = response.triggers.rows[0]
      // Don't know what is this code for
      if (trigger.onCustomActionTypeName && trigger.onActionTypeUserView) {
        for (let i = 0; i < trigger.onActionType.length; i++) {
          if (trigger.onActionType[i] === 'ACTION_CUSTOM') {
            trigger.onActionTypeUserView[i] = `${trigger.onActionTypeUserView[i]} (${trigger.onCustomActionTypeName})`
          }
        }
      }
      vuexContext.commit('SET_SELECTED_TRIGGER', trigger)
    } catch (e) {
      console.log(e)
      vuexContext.commit('SET_SELECTED_TRIGGER', {})
    }
  },
  async getTriggerActionTypesList (vuexContext) {
    try {
      const response = await triggersService.getTriggerActionTypesList(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid
      )
      vuexContext.commit('SET_TRIGGER_ACTION_TYPES_LIST', response.actionTypes)
    } catch (e) {
      console.log(e)
      vuexContext.commit('SET_TRIGGER_ACTION_TYPES_LIST', [])
    }
  },
  async getTriggerToDoList (vuexContext) {
    try {
      const response = await triggersService.getTriggerToDoList(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid
      )
      vuexContext.commit('SET_TRIGGER_TODO_LIST', response.todos)
    } catch (e) {
      console.log(e)
      vuexContext.commit('SET_TRIGGER_TODO_LIST', [])
    }
  },
  async getTriggerUsers (vuexContext, id) {
    try {
      const response = await triggersService.getTriggerUsers(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        id,
        vuexContext.state.paginationTriggerUsers
      )
      vuexContext.commit('SET_TRIGGER_USERS', response.triggerUsers.rows)
      vuexContext.commit('SET_TOTAL_TRIGGER_USERS', response.triggerUsers.count)
    } catch (e) {
      console.log(e)
      vuexContext.commit('SET_TRIGGER_USERS', [])
      vuexContext.commit('SET_TOTAL_TRIGGER_USERS', 0)
    }
  },
  async getTriggers (vuexContext) {
    try {
      const response = await triggersService.getTriggers(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.paginationTriggers,
        vuexContext.state.title,
        vuexContext.state.search
      )
      vuexContext.commit('SET_TOTAL_TRIGGERS', response.triggers.count)
      vuexContext.commit('SET_TRIGGERS', response.triggers.rows)
    } catch (e) {
      console.log(e)
      vuexContext.commit('SET_TOTAL_TRIGGERS', 0)
      vuexContext.commit('SET_TRIGGERS', [])
    }
  },
  async updateTrigger (vuexContext, data) {
    try {
      await triggersService.updateTrigger(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        data
      )
    } catch (e) {
      console.log(e)
    }
  }
}

const getters = {
  triggerActionTypes (state) {
    const triggerActionTypes = [...state.triggerActionTypes]
    return triggerActionTypes.map(action => {
      const { text, ...all } = action
      return { text: i18n.t(`general.${action.const}`), ...all }
    })
  },
  triggerToDoList (state) {
    const triggerToDoList = [...state.triggerToDoList]
    return triggerToDoList.map(action => {
      const { text, ...all } = action
      return { text: i18n.t(`general.${action.value}`), ...all }
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
